import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px p-10" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { class: "fv-row mb-10" }
const _hoisted_5 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }

import { ref, onMounted } from "vue";
import { ErrorMessage, Field } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFA',
  setup(__props) {

const store = useStore();
console.log(store.state.AuthModule.hasUserVerified2Fa);
const router = useRouter();
const { t } = useI18n();
const submitButton = ref<HTMLButtonElement | null>(null);

onMounted(() => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
});

const twoFaCode = ref("");

const isLoading = ref(false);
const submit2FaCode = async (verificationCode: string) => {
  isLoading.value = true;
  try {
    await TenantGlobalService.verify2FaVerificationCode(verificationCode);
    MsgPrompt.success("Two Factor Authentication Verification Succeed")
      .then(async () => await store.dispatch(Actions.TWOFA_VERIFIED))
      .then(() => router.push({ name: "dashboard" }));
  } catch (error) {
    MsgPrompt.error(error || "Error");
  } finally {
    isLoading.value = false;
  }
};
//form submit function
const onSubmitLogin = async (values) => {
  if (submitButton.value) {
    // eslint-disable-next-line
    submitButton.value!.disabled = true;
    // Activate indicator
    submitButton.value.setAttribute("data-kt-indicator", "on");
  }

  // Send 2fa request
  await store.dispatch(Actions.TWOFA, values);
  const [errorName] = Object.keys(store.getters.getErrors);
  const error = store.getters.getErrors[errorName];
  if (!error) {
    Swal.fire({
      text: t("common.logInSucceed"),
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: t("tip.gotIt"),
      customClass: {
        confirmButton: "btn fw-semobold btn-light-primary",
      },
    }).then(function () {
      // Go to page after successfully login
      router.push({ name: "dashboard" });
    });
  } else {
    Swal.fire({
      text: error[0],
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("tip.tryAgain"),
      customClass: {
        confirmButton: "btn fw-semobold btn-light-danger",
      },
    });
  }

  //Deactivate indicator
  submitButton.value?.removeAttribute("data-kt-indicator");
  // eslint-disable-next-line
  submitButton.value!.disabled = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "form w-100",
      onSubmit: onSubmitLogin
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("tip.twoFA")) + " Backend", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("fields.code")), 1),
        _createVNode(_unref(Field), {
          modelValue: twoFaCode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((twoFaCode).value = $event)),
          tabindex: "1",
          class: "form-control form-control-lg form-control-solid",
          type: "text",
          name: "code",
          autocomplete: "off"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(ErrorMessage), { name: "code" })
          ])
        ])
      ]),
      _createVNode(LoadingButton, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (submit2FaCode(twoFaCode.value))),
        class: "btn btn-lg btn-primary w-100 mb-5",
        "is-loading": isLoading.value,
        "save-title": _ctx.$t('action.continue')
      }, null, 8, ["is-loading", "save-title"])
    ], 32)
  ]))
}
}

})